/**
 * AES-GCM + PBKDF2 encryption compatible with Java
 * Format: IV + SALT + CIPHERTEXT
 * Returns Base64 string
 */


const PASSWORD = "df4a60512aabf59b165c7e224b83c74da71ea62e4bfb1057db0419abcafa6c5d6d2ff1cef908269ec390320ccc4a6e36004487ed977c25d6243d5154d941a003";


const ITERATIONS = 65536;
const KEY_LENGTH = 256;
const IV_LENGTH_BYTE = 12;
const SALT_LENGTH_BYTE = 16;
const TAG_LENGTH_BIT = 128;

const encoder = new TextEncoder();

const concatBuffers = (...buffers: ArrayBuffer[]) => {
    const totalLength = buffers.reduce((sum, b) => sum + b.byteLength, 0);
    const result = new Uint8Array(totalLength);
    let offset = 0;
    buffers.forEach(b => {
        result.set(new Uint8Array(b), offset);
        offset += b.byteLength;
    });
    return result;
}

const getAESKeyFromPassword = async (password: string, salt: Uint8Array): Promise<CryptoKey> => {
    const baseKey = await crypto.subtle.importKey(
        "raw",
        encoder.encode(password),
        "PBKDF2",
        false,
        ["deriveKey"]
    );

    return crypto.subtle.deriveKey(
        {
            name: "PBKDF2",
            salt: salt as BufferSource,
            iterations: ITERATIONS,
            hash: "SHA-256",
        },
        baseKey,
        {
            name: "AES-GCM",
            length: KEY_LENGTH,
        },
        false,
        ["encrypt"]
    );
}

export const encryptPayload = async (payload: NestedObject): Promise<string> => {
    const iv = crypto.getRandomValues(new Uint8Array(IV_LENGTH_BYTE));
    const salt = crypto.getRandomValues(new Uint8Array(SALT_LENGTH_BYTE));

    const aesKey = await getAESKeyFromPassword(PASSWORD, salt);

    const encryptedBuffer = await crypto.subtle.encrypt(
        {
            name: "AES-GCM",
            iv: iv,
            tagLength: TAG_LENGTH_BIT,
        },
        aesKey,
        encoder.encode(JSON.stringify(payload))
    );

    const finalBytes = concatBuffers(iv.buffer, salt.buffer, encryptedBuffer);

    return btoa(String.fromCharCode(...finalBytes));
}
